//  Externals
import { Link, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
//  Internals
import CS from "../../services/commonService";
import { URL } from "../../constants/URL";
import Theme from "../common/theme";
import { useForgotPassword } from "../../queryHooks";
import { forgotPasswordSchema } from "../../validations";
import { useStore } from "../../zustand/store";
//	Component starts
const ForgotPassword = () => {
	//	Location
	const location = useLocation();
	//	Navigation
	const navigate = useNavigate();
	const setLoading = useStore((state) => state.setLoading);
	//Defining state object for formik
	const [formData, setFormData] = useState({
		email: "",
	});

	/******************************************************************************************
	@Purpose    :   To initialize forgot password query
	*******************************************************************************************/
	const {
		mutateAsync: forgotPassword,
		error: errorForgotPassword,
		data: dataForgotPassword,
	} = useForgotPassword();

	/******************************************************************************************
	@Purpose    :   Validate and call forgot password
	*******************************************************************************************/
	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: forgotPasswordSchema,
		onSubmit: (value) => {
			forgotPassword(value);
			setLoading(true);
		},
	});

	useEffect(() => {
		setFormData({
			email: location.state != null ? location.state.emailId : "",
		});
	}, [location]);

	/******************************************************************************************
	@Purpose    :   To catch the response of verify reset token
	*******************************************************************************************/
	useEffect(() => {
		if (dataForgotPassword) {
			setLoading(false);
			if (dataForgotPassword.status === "success") {
				CS.showSuccessMessage(dataForgotPassword.message);
			}
		}
	}, [dataForgotPassword]);

	useEffect(() => {
		if (errorForgotPassword) {
			setLoading(false);
			CS.showErrorMessage(errorForgotPassword.response?.data?.message);
		}
	}, [errorForgotPassword]);

	return (
		<>
			<Theme />
			<div
				className="login-wrapper"
				style={{
					background:
						"url(../assets/images/login-bg.jpg) no-repeat center center",
				}}
			>
				<div className="login-body">
					<div className="login-container row m-0">
						<div className="col-xl-8 col-11">
							<div className="card bg-login-card">
								<div className="row m-0">
									<div className="col-md-6 col-12 pl-0 pr-0">
										<div className="card rounded-left mb-0 p-4 d-flex justify-content-center h-100">
											<div className="card-header">
												<div className="card-title text-center mb-4">
													<h4 className="mb-2 mt-2">Forgot Password?</h4>
												</div>
												<div className="text-center mb-3">
													<p className="common-small-text">
														Enter the email you used when you joined and we will
														send you set password link
													</p>
												</div>
											</div>
											<div className="card-content">
												<div className="card-body">
													<form onSubmit={handleSubmit}>
														<div className="form-group mb-4">
															<label htmlFor="emailId">
																Email<sup className="text-danger">*</sup>
															</label>
															<input
																type="text"
																className={
																	errors.email
																		? "form-control input-error"
																		: "form-control"
																}
																id="email"
																placeholder="Email"
																value={values.email}
																onChange={handleChange}
															/>
															<span className="text-danger error-msg">
																{errors.email && touched.email
																	? errors.email
																	: null}
															</span>
														</div>
														<button
															type="submit"
															className="btn btn-primary glow position-relative btn-block"
														>
															Send Email
														</button>
													</form>
													<div className=" d-flex flex-md-row flex-column justify-content-between align-items-center mt-4 mb-3">
														<div className="text-left common-small-text">
															<small>
																{" "}
																<Link to="/">Sign in</Link>
															</small>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-6 d-md-block d-none text-center align-self-center p-7">
										<div className="card-content">
											<img
												className="img-fluid"
												src="../assets/images/register.png"
												alt="sign up"
												width="300"
											></img>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ForgotPassword;
